import makeStyles from '@material-ui/core/styles/makeStyles';

export const useNewAuthDialogFormStyles = makeStyles(
    (theme) => ({
        root: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            minWidth: 380,
            maxWidth: 380,
            paddingBottom: 20,

            [theme.breakpoints.down('xs')]: {
                minWidth: '100%',
                width: '100%',
                flex: '1 1 auto',
            },

            '& $content': {
                width: '100%',
            },
        },
        claimclose: {
            position: 'absolute',
            top: 8,
            right: 8,
            color: 'white',
            zIndex: 99,
        },
        claimCloseSiginin: {
            position: 'absolute',
            top: 8,
            right: 8,
            zIndex: 99,
        },
        claimsubtitle: {
            position: 'absolute',
            top: '210px',
            width: 'fit-content',
            fontSize: '14px!important',
            lineHeight: '20px',
            letterSpacing: '0.15px!important',
            color: 'rgba(0, 0, 0, 0.54)',
        },
        claimInput: {
            marginTop: 14,

            '&.react-tel-input': {
                marginTop: 30,
            },

            '&:first-child': {
                marginTop: 0,
            },

            '& .special-label': {
                display: 'block',
                position: 'absolute !important',
                top: -15,
                left: 0,
                padding: 0,
            },

            '& .MuiFormLabel-root, & .special-label': {
                fontSize: 12,
                color: '#000',
                letterSpacing: '0.3px',
                position: 'relative',
                transform: 'translate3d(0, 0, 0)',
                marginLeft: 2,
            },

            '& .MuiFormHelperText-root': {
                marginTop: 2,
                marginLeft: 2,
            },

            '& .MuiInput-root': {
                border: '1px solid #ccc',
                borderRadius: 4,
                marginTop: 2,
                animation: 'none',

                '&:after, &:before': {
                    display: 'none',
                },
            },

            '& .MuiInput-input, & input': {
                fontSize: 14,
                color: 'rgba(0, 0, 0, 0.87)',
            },
            '& .PhoneField-field-27 input.form-control': {
                height: 24,
            },
            '& .MuiInput-input': {
                padding: '10px 14px',
                height: 24,
                fontSize: 16,
            },

            '& .MuiInputLabel-formControl': {
                color: '#000',
                padding: 0,
                margin: 0,
            },

            '& .MuiIconButton-root': {
                width: '18px',
                height: '18px',
                padding: '0 20px 0 0',
                color: 'rgba(0,0,0,0.54)',
            },
        },
        claimcontent: {
            display: 'flex',
            flexDirection: 'column',
            padding: '22px 0 0 0',
            flex: '1 1 auto',
            marginTop: '220px',
            marginLeft: '10px',
            marginRight: '10px',
            '&.full': {
                width: '90%',
            },

            '& .link': {
                margin: '0 4px',
                textDecoration: 'underline',
            },

            '&.privacy': {
                paddingBottom: 30,
            },

            '& .MuiFormControl-root': {
                width: '100%',
            },

            '& .MuiTypography-root.MuiTypography-caption': {
                display: 'none',
            },

            '& .MuiLink-root .MuiTypography-root.MuiTypography-caption': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                paddingTop: '6.5px',
            },
        },
        content: {
            display: 'flex',
            flexDirection: 'column',
            padding: '22px 0 0 0',
            flex: '1 1 auto',

            '&.full': {
                width: '90%',
            },

            '& .link': {
                margin: '0 4px',
                textDecoration: 'underline',
            },

            '&.privacy': {
                paddingBottom: 30,
            },

            '& .MuiFormControl-root': {
                width: '100%',
            },

            '& .MuiTypography-root.MuiTypography-caption': {
                display: 'none',
            },

            '& .MuiLink-root .MuiTypography-root.MuiTypography-caption': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                paddingTop: '6.5px',
            },
        },
        footer: {
            display: 'flex',
            flexDirection: 'column',
            paddingTop: 16,
            flex: '1 1 auto',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',

            '&.signup': {
                paddingTop: 20,
            },
        },
        caption: {
            padding: '0 0 5px 0',
        },
        button: {
            borderRadius: 3,
            padding: theme.spacing(0.5, 2),
            width: '100%',
            height: '36px',
        },

        link: {
            fontSize: 12,
            color: 'rgba(0, 0, 0, 0.6)',
            marginTop: 4,
        },

        dropdownField: {
            marginTop: '3px',

            '& .MuiSelect-outlined': {
                padding: '10.5px 32px 10.5px 14px',
            },

            '& .MuiOutlinedInput-root': {
                borderRadius: '4px',
            },

            '& .MuiFormHelperText-root': {
                margin: '3px 0 0 0',
            },
        },

        field: {
            marginTop: 14,

            '& .Mui-focused': {
                outlineColor: '#e4002b !important',
                outlineStyle: 'auto !important',
            },

            '&.react-tel-input': {
                marginTop: 30,
            },

            '&:first-child': {
                marginTop: 0,
            },

            '& .special-label': {
                display: 'block',
                position: 'absolute !important',
                top: -15,
                left: 0,
                padding: 0,
            },

            '& .MuiFormLabel-root, & .special-label': {
                fontSize: 12,
                color: '#000',
                letterSpacing: '0.3px',
                position: 'relative',
                transform: 'translate3d(0, 0, 0)',
                marginLeft: 2,
            },

            '& .MuiFormHelperText-root': {
                marginTop: 2,
                marginLeft: 2,
                outlineColor: '#fff !important',
                outlineStyle: 'none !important',
            },

            '& .MuiInput-root': {
                border: '1px solid #ccc',
                borderRadius: 4,
                marginTop: 2,
                animation: 'none',

                '&:hover': {
                    border: '1px solid',
                },

                '&:after, &:before': {
                    display: 'none',
                },
            },

            '& .MuiInput-input, & input': {
                fontSize: 14,
                color: 'rgba(0, 0, 0, 0.87)',
            },

            '& .MuiInput-input': {
                padding: '10px 14px',
                height: 20,
                fontSize: 16,
            },

            '& .MuiInputLabel-formControl': {
                color: '#000',
                padding: 0,
                margin: 0,
                outlineColor: '#fff !important',
                outlineStyle: 'none !important',
            },

            '& .MuiIconButton-root': {
                width: '18px',
                height: '18px',
                padding: '0 20px 0 0',
                color: 'rgba(0,0,0,0.54)',
            },
        },

        actions: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            paddingBottom: 20,
            paddingTop: 20,
            flexDirection: 'column',
        },

        divider: {
            width: '100%',
        },

        links: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',

            '&.limit': {
                maxWidth: 340,
            },

            '& .MuiTypography-root': {
                textAlign: 'center',
            },

            '& .MuiLink-root': {
                margin: '0 4px',
            },
        },
    }),
    {
        name: 'NewAuthDialogForm',
    },
);
